// Be sure the values are in sync with css breakpoint tokens

export const breakpoints = {
  xs: 320,
  s: 375,
  m: 768,
  l: 1024,
  xl: 1440,
  xxl: 1920
};
